// Utility untuk mengelola data pendidikan S1/S2/S3
// Data disimpan sebagai JSON string di kolom `education`
// Format baru: {"s1_kampus":"...","s1_jurusan":"...","s2_kampus":"...","s2_jurusan":"...","s3_kampus":"...","s3_jurusan":"..."}

export const parseEducation = (education) => {
  const empty = { s1_kampus: '', s1_jurusan: '', s2_kampus: '', s2_jurusan: '', s3_kampus: '', s3_jurusan: '' };
  if (!education) return empty;
  try {
    const parsed = JSON.parse(education);
    // Support new format
    if ('s1_kampus' in parsed || 's1_jurusan' in parsed) {
      return {
        s1_kampus: parsed.s1_kampus || '',
        s1_jurusan: parsed.s1_jurusan || '',
        s2_kampus: parsed.s2_kampus || '',
        s2_jurusan: parsed.s2_jurusan || '',
        s3_kampus: parsed.s3_kampus || '',
        s3_jurusan: parsed.s3_jurusan || '',
      };
    }
    // Legacy format: {"s1":"Univ","s2":"Univ","s3":"Univ"} → treat as kampus only
    return {
      s1_kampus: parsed.s1 || '', s1_jurusan: '',
      s2_kampus: parsed.s2 || '', s2_jurusan: '',
      s3_kampus: parsed.s3 || '', s3_jurusan: '',
    };
  } catch {
    // Plain text → treat as S1 kampus
    return { ...empty, s1_kampus: education };
  }
};

export const formatEducation = (data) => {
  return JSON.stringify({
    s1_kampus: data.s1_kampus || '',
    s1_jurusan: data.s1_jurusan || '',
    s2_kampus: data.s2_kampus || '',
    s2_jurusan: data.s2_jurusan || '',
    s3_kampus: data.s3_kampus || '',
    s3_jurusan: data.s3_jurusan || '',
  });
};

// Untuk tampilan singkat (1 baris)
export const educationSummary = (education) => {
  const edu = parseEducation(education);
  const parts = [];
  if (edu.s1_kampus) parts.push(edu.s1_kampus);
  if (edu.s3_kampus) parts.push(edu.s3_kampus);
  else if (edu.s2_kampus) parts.push(edu.s2_kampus);
  return parts.join(' → ') || '-';
};

// Untuk mendapat almamater PIMNAS (S1 kampus)
export const getAlmamater = (education) => {
  return parseEducation(education).s1_kampus || '-';
};
